import React from 'react';

const CircleArrow = () =>
<svg className="circle-arrow" xmlns="http://www.w3.org/2000/svg" width="48.555" height="48.233" viewBox="0 0 48.555 48.233">
  <path id="Subtraction_1" data-name="Subtraction 1" d="M23.777,47.233A23.784,23.784,0,0,1,6.964,40.316a23.587,23.587,0,0,1,7.558-38.46A23.863,23.863,0,0,1,40.591,6.917a23.585,23.585,0,0,1-7.558,38.46A23.77,23.77,0,0,1,23.777,47.233ZM12.8,22.636a.976.976,0,1,0,0,1.952H30.073l-6.409,6.441a.975.975,0,0,0,.781,1.562.97.97,0,0,0,.585-.194l8.1-8.1a.981.981,0,0,0,0-1.366l-8.1-8.1a.976.976,0,0,0-1.276.091.98.98,0,0,0-.09,1.275l6.409,6.442Z" transform="translate(0.5 0.5)" fill="#fff" stroke="rgba(0,0,0,0)" strokeMiterlimit="10" strokeWidth="1"/>
</svg>

;

export default CircleArrow;